import { useQuery } from 'react-query';
import { authFetch } from '../../../../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../../../../../../_hooks/useClientId';
import { queryKeys } from './queryKeys';

interface SourceAccountDTO {
  Id: string;
  Name: string;
  AvailableAmount: number;
  EntityId: string;
  IsSimulatedSource: boolean;
  SimulatedAccountType: number;
}

interface SourceAccountsDTO {
  SourcesForNonQualifiedAnnuities: SourceAccountDTO[];
  SourcesForQualifiedAnnuities: SourceAccountDTO[];
  SourcesForRothAnnuities?: SourceAccountDTO[];
}

interface FetcherParams {
  clientId: number;
  fpId: string;
  year: number | null;
  accountOwner: string | null;
}

const fetchSourceAccounts = async ({
  clientId,
  fpId,
  year,
  accountOwner,
}: FetcherParams): Promise<SourceAccountsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/WhatIfAnnuityPurchase/GetSources', {
      clientId,
      fpId,
      year,
      accountOwner,
    }),
  );
};

interface QueryParams {
  year: number | null;
  fpId: string;
  accountOwner: string | null;
  isApplied: boolean;
}

export const useSourceAccountsQuery = ({ year, fpId, accountOwner, isApplied }: QueryParams) => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.sourceAccounts(clientId, fpId, year, accountOwner),

    () => fetchSourceAccounts({ clientId, fpId, year, accountOwner }),

    {
      cacheTime: 0,
      enabled: !!year && !!fpId && !!accountOwner && !isApplied,
    },
  );
};
